import { ChevronLeft } from "lucide-react";

interface CaptureHeaderProps {
  title?: string;
  onBack?: () => void;
  backLabel?: string;
}

export default function CaptureHeader({ title, onBack, backLabel }: CaptureHeaderProps) {
  return (
    <>
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="absolute top-3 left-3 z-10 flex h-8 w-8 items-center justify-center rounded-full text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          aria-label={backLabel}
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
      )}
      {title && (
        <p className="absolute top-3 left-1/2 -translate-x-1/2 z-[5] text-sm font-semibold text-foreground pointer-events-none max-w-[60%] truncate text-center">
          {title}
        </p>
      )}
    </>
  );
}
